import React from 'react';


import MultiButtonSwitch from '../common/editors/MultiButtonSwitch';

export default function ModelSubtypeSelector({ type, value, onChange, ... props }) {
  let options = []; 
  let optionColorMap = [];
  
  // Also shown when a non-submodel has a stale subtype, so it can be cleared
  if (type === 'submodel' || value) {
    options = ['genName', 'powertrainVariation', 'bodyVariation', 'trimVariation'];
  }

  return <MultiButtonSwitch value={value} onChange={onChange} options={options} optionColorMap={optionColorMap} nullable={true} {... props}/>
}
